<template>
  <div class="tenant-form">
    <h2>Upload Tenant Excel Sheet</h2>
    <form @submit.prevent="submitTenant">
      <!-- File Upload Input -->
      <div class="form-group">
        <label for="excel-file">Upload Excel File:</label>
        <input
          type="file"
          id="excel-file"
          @change="handleFileUpload"
          accept=".xls,.xlsx"
        />
      </div>

      <!-- Display Parsed Data -->
      <div v-if="excelData.length > 0" class="parsed-data">
        <h3>Preview Data</h3>
        <ul>
          <li v-for="(item, index) in excelData" :key="index">
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="loading-message">
        <p>Uploading tenants... Please wait.</p>
      </div>

      <!-- Submit Button -->
      <button type="submit" :disabled="loading || excelData.length === 0">
        Upload and Save
      </button>
    </form>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import { addDoc, collection, getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const db = getFirestore();
const auth = getAuth();

export default {
  data() {
    return {
      excelData: [], // Holds parsed Excel data
      loading: false, // Loading state during upload
    };
  },
  methods: {
    // Handle file upload and parse Excel data
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();

      // Read file as ArrayBuffer
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Get first sheet data
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert to JSON and store in `excelData`
        this.excelData = XLSX.utils.sheet_to_json(sheet);
        console.log("Parsed Excel Data:", this.excelData);
      };

      reader.readAsArrayBuffer(file);
    },

    // Submit parsed data to Firestore
    async submitTenant() {
      if (this.loading) return; // Prevent duplicate submissions
      this.loading = true;

      try {
        // Ensure user is authenticated
        const user = auth.currentUser;
        if (!user) {
          alert("You must be logged in to upload tenants.");
          this.loading = false;
          return;
        }


        //excelData
        // Process each row and save to Firestore
        for (const row of this.excelData) {
          const tenant = {
            reference: row.REFERENCE || "",
            type: row.TYPE || "Consumer",
            displayName: row["TRADING NAME"] || row["LEGAL NAME"] || "",
            emails: [row.EMAIL || ""],
            numbers: [{ number: row.NUMBERS || "" }],
            addresses: [row["DESCRIPTION"] || ""],
            person: {
              firstName: row["FIRST NAMES"] || "",
              surname: row.SURNAME || "",
              rsaIdNumber: row.IDENTIFIER || "",
            },
            userUid: user.uid, // Attach uploader UID
          };

          console.log("Uploading tenant data:", tenant);

          await addDoc(collection(db, "tenants"), tenant);
        }

        // Reset form state
        this.loading = false;
        this.excelData = [];
        alert("Tenants uploaded successfully!");
        this.$router.push("/tenants");
      } catch (error) {
        console.error("Error uploading tenants:", error);
        this.loading = false;
        alert("An error occurred while uploading tenants.");
      }
    },
  },
};
</script>

<style scoped>
.tenant-form {
  max-width: 600px;
  margin: 20px auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2,
h3 {
  text-align: center;
  color: #333;
  margin-bottom: 15px;
}

.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: bold;
  color: #555;
  display: block;
  margin-bottom: 5px;
}

input[type="file"] {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button[type="submit"] {
  display: block;
  width: 100%;
  background-color: #007bff;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
}

button[type="submit"]:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.loading-message {
  text-align: center;
  font-size: 1rem;
  color: #007bff;
}

.parsed-data {
  margin: 15px 0;
  background-color: #f0f0f0;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.parsed-data ul {
  list-style: none;
  padding: 0;
}

.parsed-data li {
  margin-bottom: 5px;
  font-size: 0.9rem;
}
</style>
